const URL_TEST = 'https://kiron-test.novigo-consulting.it/api'; // eslint-disable-line
const URL_STAGING = 'https://kiron-staging.novigo-consulting.it/api'; // eslint-disable-line
const URL_MIGRATION = 'https://apikirontest.novigo-consulting.it'; // eslint-disable-line
const URL_E2E = 'https://kiron-testaut.novigo-consulting.it/api'; // eslint-disable-line
const URL_PROD = 'https://kiron.novigo-consulting.it/api'; // eslint-disable-line
const URL_DOCKER = 'http://localhost:8889'; // eslint-disable-line

let baseUrl = URL_DOCKER;

export const ENV_SETTINGS = {
  ga: {
    development: 'UA-162313271-1',
    test: 'UA-161488584-1',
    staging: 'UA-162330023-1',
    production: 'UA-162269164-1',
  },
  // I lead vengono eliminati dopo x giorni dall'importazione in anagrafica se non viene caricato il documento privacy.
  GIORNI_SCADENZA_GDPR: 15,
  DATA_SPLIT_DOCUMENTO_AVC: 1607033323, // 03/12/2020 22:08:00 GMT
  DATA_CHANGE_MANAGEMENT_DD: 1620478800, // 09/05/2021 13:00:00
};

switch (process.env.NODE_ENV) {
  case 'production': {
    baseUrl = URL_PROD;
    break;
  }
  case 'staging': {
    baseUrl = URL_STAGING;
    break;
  }
  case 'test': {
    baseUrl = URL_TEST;
    break;
  }
  default: {
    console.log('Ambiente di default'); // eslint-disable-line
    break;
  }
}

export const ENV = process.env.NODE_ENV;

// Temporarily hide manual MRETE actions for the production release. Set to true to re-enable them.
export const SHOW_MRETE_ACTIONS = false;

// Stati diligence
export const DILIGENCE = {
  NON_RICHIESTA: 'NON RICHIESTA', // Conferma
  PENDING: 'PENDING',
  SOSPESA: 'SOSPESA',
  SCADUTA: 'SCADUTA', // Conferma
  EVASA_OK: 'OK', // Conferma
  EVASA_KO: 'KO',
  SCADENZA_DD_MUTUO: 15,
  SCADENZA_DD_ALTRI: 10,
};

// Tipologia firma soggetto
export const TIPOLOGIA_FIRMA_SOGGETTO = {
  MANCANTE: 0,
  TRADIZIONALE: 1,
  ELETTRONICA: 2,
};

// Tipologia firma privacy
export const TIPOLOGIA_FIRMA_PRIVACY = {
  TRADIZIONALE: 1,
  ELETTRONICA_SEMPLICE: 2,
  ELETTRONICA_AVANZATA: 3,
};

export const ITALIAN_MONTH_NAMES = [
  'Gennaio',
  'Febbraio',
  'Marzo',
  'Aprile',
  'Maggio',
  'Giugno',
  'Luglio',
  'Agosto',
  'Settembre',
  'Ottobre',
  'Novembre',
  'Dicembre',
];

export const MAIN_DASHBOARD_TAB_CONFIG = {
  main: {
    label: 'Main Dashboard View',
    method: 'main-dashboard',
    filtersToOmit: ['dettaglioProvenienza'],
  },
  fatturato: {
    label: 'Fatturato',
    method: 'fatturato-personale',
    filtersToOmit: ['dettaglioProvenienza'],
  },
  payin: {
    label: 'Payin',
    method: 'payin',
    filtersToOmit: ['dettaglioProvenienza'],
  },
  // payout: {
  //   label: 'Payout',
  //   method: 'payout',
  //   filtersToOmit: ['dettaglioProvenienza'],
  // },
  prodotti: {
    label: 'Prodotti',
    method: 'prodotti',
    filtersToOmit: ['dettaglioProvenienza'],
  },
  lead: {
    label: 'Efficacia',
    method: 'lead',
    filtersToOmit: ['list', 'export', 'prodotti', 'provenienza', 'finalita', 'istituto', 'parentIstituto'],
  },
  activity: {
    label: 'Attività',
    method: 'activity',
    filtersToOmit: ['list', 'export', 'prodotti', 'provenienza', 'finalita', 'istituto', 'parentIstituto'],
  },
  'pubblicazione-fatture': {
    label: 'Pubblicazione fatture',
    method: 'invoice-publication',
    filtersToOmit: [
      'list',
      'export',
      'prodotti',
      'collaboratore',
      'responsabileArea',
      'senior',
      'dettaglioProvenienza',
      'provenienza',
      'finalita',
      'agenzia',
    ],
  },
  monitoraggio: {
    label: 'Monitoraggio',
    method: 'monitoraggio',
    filtersToOmit: ['list', 'export', 'prodotti', 'dettaglioProvenienza', 'finalita', 'istituto', 'parentIstituto'],
  },
};

export const CMSG_DUE_WEEK_1ST = '1w';
export const CMSG_DUE_WEEK_2ND = '2w';
export const CMSG_DUE_WEEK_3RD = '3w';
export const CMSG_DUE_WEEK_4TH = '4w';
export const CMSG_DUE_FORTNIGHT_1ST = '1fn';
export const CMSG_DUE_FORTNIGHT_2ND = '2fn';

export const CMSG_DUE_WEEK_OPTIONS = {
  /*  Removed for task @KIR2020005-1860
      [CMSG_DUE_WEEK_1ST]: 'I settimana',
      [CMSG_DUE_WEEK_2ND]: 'II settimana',
      [CMSG_DUE_WEEK_3RD]: 'III settimana',
      [CMSG_DUE_WEEK_4TH]: 'IV settimana',  */
  [CMSG_DUE_FORTNIGHT_1ST]: 'I quindicina',
  [CMSG_DUE_FORTNIGHT_2ND]: 'II quindicina',
};

/** API ENDPOINTS */
export const API = {
  BASEURL: baseUrl,
  ACCESS_TOKEN: '/hybridauth/login/Tecnocasa',
  REFRESH_TOKEN: '/hybridauth/refreshToken/Tecnocasa',
  ANAGRAFICA: '/anagrafica',
  PROVENIENZA: '/provenienza',
  RUOLO: '/ruolo',
  PROFILO_COLLABORATORE: '/profilocollaboratore',
  CONTRATTO_COLLABORATORE: '/contrattocollaboratore',
  AGENZIA_KIRON: '/agenziakiron',
  AGENZIA_TECNOCASA: '/agenziatecnocasa',
  TIPO_PROFILO_COLLABORATORE: '/tipoprofilocollaboratore',
  COLLABORATORE: '/collaboratore',
  GRUPPO_AGENZIA_KIRON: '/gruppoagenziakiron',
  RESPONSABILE_AREA: '/responsabile-area',
  INTERNO_KIRON: '/interno-kiron',
  PROFILO_INTERNO: '/profilo-interno',
  COORDINATORE: '/coordinatore',
  CLIENTE: '/cliente',
  OCCUPAZIONE: '/occupazione',
  AREA_TECNOCASA: 'area-tecnocasa', // TODO: uniformare a formato altre api con slash
  PRATICA: '/pratica',
  SOGGETTO: '/soggetto',
  ADEGUATEZZA: '/adeguatezza',
  FINALITA: '/finalita',
  FINALITA_PRESTITO: '/finalita-prestito',
  ISTITUTI: '/istituto',
  ISTITUTO_NON_CONVENZIONATO: '/istituto-non-convenzionato',
  PRATICA_MUTUO: 'pratica-mutuo', // TODO: uniformare a formato altre api con slash
  PRATICA_PRESTITO: '/pratica-prestito', // TODO: uniformare a formato altre api con slash
  PRATICA_CQS: '/pratica-cqs',
  PRATICA_ASSICURAZIONE: '/pratica-assicurazione',
  PRE_CONTRATTO: 'pre-contratto', // TODO: uniformare a formato altre api con slash
  PRODOTTO_ACCESSORIO_ISTITUTO: '/prodotto-accessorio-istituto',
  LIST_ITEM: '/list-item',
  PROFESSIONE: '/professione',
  PRODOTTO_ACCESSORIO_BROKER: '/gestione-prodotto-accessorio-broker',
  PRODOTTO_MUTUO: '/prodotto-mutuo',
  PRODOTTO_PRESTITO: '/prodotto-prestito',
  PRODOTTO_CQS: '/prodotto-cqs',
  PRODOTTO_ACCESSORIO: '/tipo-prodotto-accessorio',
  INCASSO: '/incasso',
  NOTA_PRATICA: '/nota-pratica',
  NOTA_ANTIRICICLAGGIO: '/nota-antiriciclaggio',
  CHAT_MESSAGE: '/chat-message',
  MAIL_PRATICA: '/message',
  EVENTO: '/evento',
  TRANSIZIONE_STATO: '/transizione-stato',
  REGOLE_PROFILO_BASE: '/regola-profilo-base',
  REGOLA: '/regola',
  IMPORTAZIONE: '/importazione',
  PRATICA_IMPORTATA: '/pratica-importata',
  COMPENSO: '/compenso',
  COMPENSO_FLUSSO: '/compenso-flusso',
  FLUSSO: '/flusso',
  NOTIZIE_CREDITIZIE: '/notizia-creditizia',
  COLLABORATORE_TECNOCASA: '/collaboratore-agenziatecnocasa',
  RICHIESTA_IMMOBILIARE: '/richiesta-immobiliare',
  FAQ: '/faq',
  COMUNI: '/comune',
  STORICO_DILIGENCE: '/storico-diligence',
  TUTOR_TUTEE: '/tutor-tutee',
  COMEDIAZIONE: '/comediazione',
  DOCUMENTI_STATICI: '/static-document',
  CATEGORIE_DOCUMENTI_STATICI: '/document-category',
  PROXY: '/forward-request',
  LIVEID_REQUEST: '/live-id-request',
  PRATICA_BLOCCATA: '/pratica-bloccata',
  COMPENSO_BLOCCATO: '/compenso-bloccato',
  PRATICA_SOLLECITATA: '/sollecito-pratica',
  SOGGETTO_BLOCCATO: '/soggetto-bloccato',
  FATTURA_PROVVIGIONE: '/fattura-provvigione',
  JOB_APPLICATION_ORIGIN: 'job-application-origin',
  JOB_APPLICATION: 'job-application',
  JOB_APPLICATION_NOTE: 'job-application-note',
  BROKER: '/broker',
  NEO_PROFILE: '/neo-user',
  NEO_AREA_NOTE: '/neo-user-note',
  NEO_RATINGS: '/neo-user-rating',
  NEO_RATINGS_RULE: '/neo-user-rating-rule',
  RECESSO: '/recesso',
  RECESSO_LIST_ITEM: '/recesso-list-item',
  RECESSO_KIRON_REASON_DETAIL: '/recesso-kiron-reason-detail',
  RECESSO_NOTE: '/recesso-note',
  AVVISO: '/avviso',
  RETE_TUTOR: '/rete-tutor',
  RETE_TUTOR_TUTEE: '/rete-tutor-tutee',
  RETE_TUTOR_NOTE: '/rete-tutor-note',
  STORICO_RIASSEGNAZIONE: '/storico-riassegnazioni',
  TERZO_COMEDIATORE: '/terzo-comediatore',
  PRIVACY_LOGGER: '/privacy-logger',
  PROCESSO_IMPRESA: '/processo-imprese',
  VISURA_CAMERALE: '/visura-camerale',
  PRIVACY_TITOLARE_EFFETTIVO: '/privacy-titolare-effettivo',
  IDENTITA_TITOLARE_EFFETTIVO: '/identita-titolare-effettivo',
  CODICE_FISCALE_TITOLARE_EFFETTIVO: '/codice-fiscale-titolare-effettivo',
};

export const RPC = {
  INFO_UTENTE_LOGGATO: '/gestione-user-acl',
  GESTIONE_NOTIZIA_CREDITIZIA: '/gestione-notizia-creditizia',
  GESTIONE_RICHIESTA_IMMOBILIARE: '/gestione-richiesta-immobiliare',
  GESTIONE_ANAGRAFICA: '/gestione-anagrafica',
  GESTIONE_DOCUMENTI_PRATICA: '/gestione-documenti-pratica',
  GESTIONE_COLLABORATORE: '/gestione-collaboratore',
  GESTIONE_STATO_PRATICA: '/gestione-stato-pratica',
  GESTIONE_REPORT: '/gestione-report',
  STATO: '/prossimo-stato-pratica',
  GENERA_DOCUMENTO: '/genera-documento',
  GESTIONE_PRATICA: '/gestione-pratica',
  GESTIONE_PRROCESSO_IMPRESE: '/gestione-processo-imprese',
  GESTIONE_PRATICHE_IMPORTATE: '/gestione-pratiche-importate',
  IMPORTAZIONE_FILE: '/importazione-file',
  AVC_JWT: '/avc-jwt',
  GESTIONE_FLUSSO: '/gestione-flusso',
  GESTIONE_COMPENSO: '/gestione-compenso',
  GENIO_DILIGENCE: '/genio-diligence-request',
  ATTIVAZIONE_UTENTE: 'l3-activate',
  DOWNLOAD: '/download',
  GESTIONE_PRODOTTO: '/gestione-prodotto',
  GESTIONE_PRODOTTO_ACCESSORIO_BROKER: 'gestione-prodotto-accessorio-broker',
  DOWNLOAD_AVC: '/documento-antiriciclaggio',
  PROVINCIA_REGIONE: '/provincia-regione',
  GESTIONE_STATISTICA: '/statistica-utilizzo',
  DASHBOARD: '/dashboard-commerciale',
  AGGIORNA_INFINITY: '/infinity',
  GESTIONE_RICHIESTA_COMEDIAZIONE: '/gestione-comediazione',
  PROXY: '/forward-request',
  SBLOCCA_DOPPIO_MUTUO: '/flag-precontratto',
  RIGENERA_DOCUMENTI: '/document-reload',
  GESTIONE_SOGGETTO: '/gestione-soggetto',
  EMAIL_UNSUBSCRIBE: '/unsubscribe',
  LIVEID_REQUEST: '/live-id-request-manager',
  DASHBOARD_COMMISSIONING: '/dashboard-commissioning',
  SIGN_MANAGER: '/sign-manager',
  JOB_APPLICATION_DASHBOARD: '/job-application-dashboard',
  JOB_APPLICATION_UPDATE_STATE: '/update-state-job-application',
  JOB_APPLICATION_DOCUMENTS: '/job-application-documents',
  KANBAN_VIEW_STATISTICS: '/kanban-view-statistics',
  NEO_AREA_DOCUMENTS: '/neo-area-documents',
  RECESSO_DOCUMENTS: '/recesso-documents',
  GESTIONE_RECESSO: '/gestione-recesso',
  GEESTIONE_AVVISO: '/gestione-avviso',
  DASHBOARD_NETWORK: '/dashboard-network',
  RECESSO_TUTOR_UPDATE_STATE: '/update-state-recesso-tutor',
  GESTIONE_RETE_TUTOR: '/gestione-rete-tutor',
  RETE_TUTOR_DOCUMENTS: '/rete-tutor-documents',
  GESTIONE_TERZO_COMEDIATORE: '/gestione-terzocomediatore',
  SETTORE_CONTROLLI: '/settore-controlli',
  APPUNTAMENTO_MANAGER: '/appointment-manager',
  PROCESSO_IMPRESA_DOCUMENTS: '/gestione-documenti-impresa',
  YOUNIQUE_BUSINESS_FORMAVC: '/younique-business-form-avc',
  YOUNIQUE_BUSINESS_PREFILTRAGGIO: '/younique-business-prefiltraggio',
};

/** REACT ROUTES */
export const ROUTES = {
  ANAGRAFICA: '/anagrafica',
  PROSPECT: '/prospect',
  PRATICA: '/pratica',
  AGENZIAKIRON: '/agenziakiron',
  ISTITUTO: '/istituto',
  PRODOTTO: '/prodotto',
  PRATICHE: '/pratiche',
  AGENDA: '/agenda',
  IMPORTAZIONE: '/importazione',
  UNSUBSCRIBE: '/unsubscribe',
  CANDIDATES_LIST: '/area-candidati',
  CANDIDATE: '/candidato',
  NEO_PROFILE_LIST: '/area-neo/profili',
  NEO_PROFILE: '/profilo-neo',
  NEO_CALENDAR: '/area-neo/calendario',
  GESTIONE_RECESSI: '/gestione-rete/recessi',
  ADD_RETE_TUTOR: '/gestione-rete/tutor',
  UPDATE_RETE_TUTOR: '/gestione-rete/updateTutor',
  PROCESSO_IMPRESE: '/processo-imprese',
};

export const DOCUMENTS = {
  PRIVACY: '/privacy',
  IDENTITA: '/identita',
  CODICE_FISCALE: '/codice-fiscale',
  CONTRATTO_COLLABORATORE: '/contratto-collaboratore-attachment',
  MODULO_IDENTIFICAZIONE: '/modulo-identificazione',
  VISURA_CAMERALE: '/visura-camerale',
  PRIVACY_TITOLARE_EFFETTIVO: '/privacy-titolare-effettivo',
  IDENTITA_TITOLARE_EFFETTIVO: '/identita-titolare-effettivo',
  CODICE_FISCALE_TITOLARE_EFFETTIVO: '/codice-fiscale-titolare-effettivo',
};

export const INTERNI_KIRON = [
  'commissioningDirezionale',
  'commissioningOperativo',
  'direzione',
  'direzioneComm',
  'productManagerMutuo',
  'productManagerCQS',
  'productManagerPrestito',
  'gestoreContratti',
  'responsabileAntiriciclaggio',
  'responsabileControlli',
];

const PRODUCT_MANAGER = ['productManagerMutuo', 'productManagerCQS', 'productManagerPrestito'];

export const ACL = {
  // PROVENIENZE
  CAN_EDIT_PROVENIENZE: ['admin'],

  // SEZIONI
  CAN_VIEW_SECTION_AGENZIE_KIRON: [
    'admin',
    'commissioningDirezionale',
    'direzione',
    'direzioneComm',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'gestoreContratti',
    'responsabileAntiriciclaggio',
    'responsabileControlli',
  ],
  CAN_VIEW_SECTION_AGENZIE_TECNOCASA: [
    'admin',
    'responsabileArea',
    'commissioningDirezionale',
    'direzione',
    'direzioneComm',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'gestoreContratti',
    'responsabileAntiriciclaggio',
    'responsabileControlli',
  ],
  CAN_VIEW_SECTION_ISTITUTI: [
    'admin',
    'commissioningDirezionale',
    'direzione',
    'direzioneComm',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'gestoreContratti',
    'responsabileAntiriciclaggio',
    'responsabileControlli',
  ],
  CAN_VIEW_SECTION_PRODOTTI: [
    'admin',
    'commissioningDirezionale',
    'direzione',
    'direzioneComm',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'gestoreContratti',
    'responsabileAntiriciclaggio',
    'responsabileControlli',
  ],
  CAN_VIEW_SECTION_COMMISSIONING: ['admin', 'commissioningDirezionale', 'commissioningOperativo'],
  CAN_VIEW_REPORT: [
    'admin',
    'collaboratore',
    'amministrazione',
    'commissioningDirezionale',
    'commissioningOperativo',
    'direzione',
    'direzioneComm',
    'gestoreContratti',
    'productManagerCQS',
    'productManagerCQS',
    'productManagerMutuo',
    'productManagerPrestito',
    'responsabileAntiriciclaggio',
    'responsabileControlli',
    'responsabileArea',
    'coordinatore',
    'senior',
    'productManagerImprese',
  ],

  // EDIT AGENZIE KIRON
  CAN_EDIT_AGENZIE: ['admin', 'gestoreContratti'],

  // ASSEGNAZIONE AGENZIE TECNOCASA
  CAN_ASSIGN_COLLABORATORE_TECNOCASA: ['gestoreContratti', 'responsabileArea', 'admin'],
  CAN_DISABLE_AGENZIE_TECNOCASA: ['gestoreContratti', 'responsabileArea', 'admin'],

  // VIEW TIPI DI ANAGRAFICHE
  CAN_VIEW_PROSPECT: [
    'admin',
    'responsabileArea',
    'commissioningDirezionale',
    'direzione',
    'direzioneComm',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'gestoreContratti',
    'responsabileAntiriciclaggio',
    'responsabileControlli',
    'coordinatore',
    'senior',
    'collaboratore',
  ],
  CAN_VIEW_COORDINATORE: ['responsabileArea', 'admin', ...INTERNI_KIRON],
  CAN_VIEW_RESPONSABILE_AREA: ['admin', ...INTERNI_KIRON],
  CAN_VIEW_INTERNO_KIRON: ['admin', ...INTERNI_KIRON],

  // VIEW MODALE TABELLA PROFILI/CO-MEDIAZIONE SENIOR
  CAN_VIEW_PROFILI_COMEDIAZIONE_SENIOR_MODAL: ['admin', 'senior'],

  // VIEW EDITOR AVVISI
  CAN_VIEW_AVVISI: ['admin', ...INTERNI_KIRON],

  // ACTION SU ANAGRAFICHE
  CAN_ACTION_COLLABORATORE: ['admin', 'gestoreContratti', 'responsabileArea'],
  CAN_TRASFERISCI_PORTAFOGLIO: ['responsabileArea', 'gestoreContratti', 'admin'],

  // EDIT TIPI DI ANAGRAFICHE
  CAN_EDIT_ANAGRAFICA: [
    'admin',
    'collaboratore',
    'senior',
    'coordinatore',
    'gestoreContratti',
    'responsabileControlli',
  ],
  CAN_EDIT_ANAGRAFICA_INFINITY: ['amministrazione'],
  CAN_EDIT_COLLABORATORE: ['admin', 'gestoreContratti'],
  CAN_EDIT_SHARED_MAIL: ['senior', ...INTERNI_KIRON],
  CAN_EDIT_COORDINATORE: ['admin', 'gestoreContratti', 'responsabileControlli'],
  CAN_EDIT_RESPONSABILE_AREA: ['gestoreContratti', 'admin'],
  CAN_EDIT_INTERNO_KIRON: ['gestoreContratti', 'admin'],
  CAN_EDIT_FIELDS_VIDEORICONOSCIUTO: ['admin', ...INTERNI_KIRON],

  // PRATICA
  CAN_EDIT_PRATICA: [
    'collaboratore',
    'senior',
    'coordinatore',
    'admin',
    'commissioningDirezionale',
    'commissioningOperativo',
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
  ],
  CAN_ADD_PRATICA: ['collaboratore', 'senior', 'coordinatore', 'admin'],
  CAN_CHANGE_PROPERTY_PRATICA: [
    'admin',
    'gestoreContratti',
    'responsabileControlli',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_CHANGE_LIQUIDABILE_PRATICA: [
    'admin',
    'responsabileControlli',
    'commissioningDirezionale',
    'commissioningOperativo',
    'direzioneComm',
  ],
  CAN_ANNULLA_PRATICA: [
    'admin',
    'gestoreContratti',
    'responsabileControlli',
    'commissioningDirezionale',
    'collaboratore',
    'senior',
    'coordinatore',
  ],
  CAN_DELETE_PRATICA: ['admin'],
  CAN_ASSIGN_COLLABORATORE: ['admin', 'coordinatore', 'gestoreContratti', 'productManagerImprese'],
  CAN_SBLOCCO_AVC: ['responsabileAntiriciclaggio', 'admin'],
  CAN_SBLOCCO_DD: [
    'responsabileControlli',
    'admin',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
  ],
  CAN_CANCEL_REQUEST_DD: ['admin', ...INTERNI_KIRON],

  // ISTITUTI
  CAN_EDIT_ISTITUTI: ['admin', 'productManagerMutuo', 'productManagerCQS', 'productManagerPrestito'],
  CAN_DELETE_ISTITUTI: ['admin'],

  // PRODOTTI
  CAN_PRODOTTO_EDIT_MUTUO: ['admin', 'productManagerMutuo'],
  CAN_PRODOTTO_EDIT_CQS: ['admin', 'productManagerCQS'],
  CAN_PRODOTTO_EDIT_PRESTITO: ['admin', 'productManagerPrestito'],

  // COMMISSIONING
  CAN_COMMISSIONING_REGOLE: ['admin', 'commissioningDirezionale'],
  CAN_FORZA_PROVVIGIONI: ['admin', 'commissioningOperativo', 'commissioningDirezionale'],
  CAN_APPROVA_PROVVIGIONI: ['admin', 'commissioningDirezionale'],

  // MODULISTICA
  CAN_EDIT_MODULISTICA: ['admin', 'direzione', 'gestoreContratti'],

  // REPORT
  CAN_VIEW_REPORT_COMMISSIONING: [
    'admin',
    'direzione',
    'direzioneComm',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningOperativo',
    'commissioningDirezionale',
  ],
  CAN_VIEW_REPORT_CONTROLLO_EVOLUZIONE_PRATICHE: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_CONTRATTI_SCADUTI: [
    'admin',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'direzioneComm',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_SURROGHE_PORTAFOGLI: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_PORTAFOGLIO_NON_ASSEGNATO: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'responsabileArea',
    'senior',
    'coordinatore',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_ANOMALIA_CONTABILIZZAZIONE: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_CONGRUENZA_DATE: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_AMMINISTRATIVO: [
    'amministrazione',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'admin',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_GENIO: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_AGENZIE_ASSEGNATE: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'responsabileArea',
    'senior',
    'commissioningDirezionale',
    'coordinatore',
    'collaboratore',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_FATTURE_COLLABORATORE: [
    'admin',
    'collaboratore',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'commissioningOperativo',
    'senior',
  ],
  CAN_VIEW_REPORT_AUDIT: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningDirezionale',
    'amministrazione',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_AUDIT_AGENZIE: [
    'admin',
    'direzione',
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
    'collaboratore',
    'senior',
    'coordinatore',
    'responsabileArea',
  ],
  CAN_VIEW_REPORT_FATTURE_CLIENTE: [
    'admin',
    'collaboratore',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningOperativo',
    'commissioningDirezionale',
    'coordinatore',
    'senior',
  ],
  CAN_VIEW_REPORT_AGENTI: [
    'admin',
    'direzione',
    'direzioneComm',
    'amministrazione',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'responsabileArea',
    'commissioningOperativo',
    'commissioningDirezionale',
  ],
  CAN_VIEW_REPORT_AGENZIE: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'commissioningOperativo',
    'commissioningDirezionale',
  ],
  CAN_VIEW_REPORT_COORDINATRICI: [
    'admin',
    'direzione',
    'direzioneComm',
    ...PRODUCT_MANAGER,
    'responsabileControlli',
    'responsabileAntiriciclaggio',
    'gestoreContratti',
    'responsabileArea',
    'commissioningOperativo',
    'commissioningDirezionale',
  ],
  CAN_VIEW_REPORT_PRATICHE_DA_LIQUIDARE: [
    'admin',
    'direzione',
    'direzioneComm',
    'commissioningOperativo',
    'collaboratore',
    'responsabileArea',
    'senior',
    'commissioningDirezionale',
  ],
  CAN_VIEW_REPORT_CLIENTI: [
    'admin',
    'direzioneComm',
    'responsabileArea',
    'collaboratore',
    'senior',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_LEAD: [
    'admin',
    'responsabileControlli',
    'responsabileArea',
    'is1ge',
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_DUE_DILIGENCE: [
    'admin',
    'responsabileControlli',
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_AVC_PENDING: [
    'admin',
    'responsabileControlli',
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_AREA_CANDIDATI: [
    'admin',
    'gestoreContratti',
    'responsabileArea',
    'direzione',
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_POLIZZE_ISTITUTO: [
    ...INTERNI_KIRON,
    'admin',
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],
  CAN_VIEW_REPORT_RECESSI: [
    'admin',
    'gestoreContratti',
    'responsabileArea',
    'responsabileControlli',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'commissioningDirezionale',
    'commissioningOperativo',
    'direzioneComm',
  ],
  CAN_VIEW_REPORT_FATTURE_RESPONSABILE_AREA: [
    'admin',
    'amministrazione',
    'commissioningDirezionale',
    'commissioningOperativo',
    'responsabileArea',
  ],

  // Statistiche
  CAN_VIEW_SECTION_STATISTICHE: ['novi1', 'novi2'],

  // Note Antiriciclaggio
  CAN_VIEW_NOTE_ANTIRICICLAGGIO: ['novi2', 'is2fc', 'is1dp', 'is2fp', 'is4mm', 'is2mz', 'is1ct', 'is3dm'],

  // Dashboard
  CAN_VIEW_SECTION_DASHBOARD: [...INTERNI_KIRON, 'admin', 'responsabileArea', 'senior', 'collaboratore', 'productManagerImprese'],
  CANNOT_VIEW_DASHBOARD: ['coordinatore'],

  // Mail da pratica
  CAN_SEND_MAIL_FROM_PRATICA: ['admin', 'commissioningOperativo', 'commissioningDirezionale'],
  MUST_SEND_TO_COMMISSIONING: ['collaboratore', 'coordinatore', 'senior'],
  CAN_SEND_REMINDER_MAIL_FROM_PRATICA: ['admin', ...INTERNI_KIRON],
  CAN_SEND_INCASSO_NON_CONFORME_FROM_PRATICA: ['admin', 'amministrazione', 'direzione'],

  // Aggiornamenti forzati Infinity
  CAN_UPDATE_INFINITY: ['admin', 'amministrazione', 'commissioningDirezionale', 'gestoreContratti'],

  // Comediazioni
  CAN_FORZA_COMEDIAZIONI: ['admin', 'direzione', 'commissioningDirezionale'],

  // Sblocco doppio mutuo
  CAN_SBLOCCA_DOPPIO_MUTUO: ['admin', 'responsabileAntiriciclaggio'],

  // Comediazioni
  CAN_REFRESH_DOCUMENTI_PRATICA: ['admin', 'ip1c2', 'ip1c1'],

  // Disabilito checkbox attive nella barra di ricerca per le pratiche
  CAN_VIEW_CHECKBOX_PRATICHE_ATTIVE_DISABLED: [...INTERNI_KIRON, 'admin'],

  // Anagrafica collaboratore
  CAN_VIEW_PIGNORAMENTO: [...INTERNI_KIRON, 'admin'],
  CAN_VIEW_COLLABORATORE_ACCESS_LOCK: [...INTERNI_KIRON, 'admin'],

  // Area candidati
  CAN_VIEW_SECTION_CANDIDATI: ['admin', 'gestoreContratti', 'responsabileArea', 'direzione'],
  CAN_UPDATE_CANDIDATI: ['admin', 'gestoreContratti', 'direzione'],
  CAN_PARTIAL_UPDATE_CANDIDATI: ['responsabileArea'],
  CAN_FORCE_MRETE_STOPLIGHTS: ['admin', 'novi1', 'novi2', 'novi3', 'novi4', 'novi5', 'novi6'],

  // Neo Area
  CAN_VIEW_SECTION_NEO_AREA: [
    'admin',
    'direzione',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'responsabileArea',
    'gestoreContratti',
  ],

  COMPLETE_PERMISSION_SECTION_NEO_AREA: [
    'admin',
    'direzione',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'gestoreContratti',
  ],

  // Gestione rete
  CAN_VIEW_SECTION_GESTIONE_RETE: [
    'admin',
    'direzione',
    'gestoreContratti',
    'responsabileArea',
    'responsabileControlli',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
    'senior',
    'coordinatore',
  ],
  CAN_VIEW_SECTION_GESTIONE_RETE_ALL_TABS: [
    'admin',
    'direzione',
    'gestoreContratti',
    'responsabileArea',
    'responsabileControlli',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
  ],

  CAN_CREATE_RECESSO: ['admin', 'gestoreContratti', 'responsabileArea'],
  CAN_REMOVE_RECESSO: ['admin', 'gestoreContratti'],
  CAN_UPDATE_STATE_RECESSO: [
    'admin',
    'direzione',
    'gestoreContratti',
    'responsabileControlli',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
  ],

  CAN_VIEW_REPORT_TUTOR: [
    'admin',
    'responsabileArea',
    'senior',
    'tutor',
    ...INTERNI_KIRON,
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],

  CAN_VIEW_RA_ON_TUTOR_REPORT: [
    'admin',
    ...INTERNI_KIRON,
    'direzioneComm',
    'commissioningDirezionale',
    'commissioningOperativo',
  ],

  CAN_VIEW_REPORT_RETE_TUTOR: ['admin', 'responsabileArea', ...INTERNI_KIRON],

  CAN_REMOVE_RECESSO_TUTOR: ['admin', 'gestoreContratti'],

  CAN_UPDATE_RETE_TUTOR: ['admin', ...INTERNI_KIRON],

  CAN_ANONYMIZE_ANAGRAFICA: ['admin', ...INTERNI_KIRON],

  CAN_VIEW_REPORT_PENETRAZIONE_POLIZZE: ['admin', ...INTERNI_KIRON],

  // Settore Controlli
  CAN_VIEW_SECTION_SETTORE_CONTROLLI: [
    'admin',
    'direzione',
    'gestoreContratti',
    'responsabileArea',
    'responsabileControlli',
    'productManagerMutuo',
    'productManagerCQS',
    'productManagerPrestito',
  ],

  // Imprese section
  CAN_SBLOCCO_IMPRESE: ['responsabileAntiriciclaggio', 'admin', 'productManagerImprese'],
  CAN_VIEW_REPORT_PRATICHE_IMPRESA: ['responsabileAntiriciclaggio', 'admin', 'productManagerImprese'],
};

export const CANCELLATO_GDPR = 'CANCELLATO GDPR';



// WEBPACK FOOTER //
// ./app/shared/constants/index.js